import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-name": "Group 5248",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.5 19.999"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8241",
  d: "M15.75 1.5H18A1.5 1.5 0 0 1 19.5 3v3.75H0V3a1.5 1.5 0 0 1 1.5-1.5h2.25V0h1.5v1.5h9V0h1.5z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8233 - Outline",
  d: "M13.751 8.5a5.75 5.75 0 1 1-5.75 5.75 5.756 5.756 0 0 1 5.75-5.75zm0 10.342a4.592 4.592 0 1 0-4.592-4.592 4.6 4.6 0 0 0 4.592 4.592zm-.579-7.819h1.158v2.845l2.031.9-.456 1.066-2.733-1.2z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8233 - Outline - Outline",
  d: "M13.651 8.5a5.75 5.75 0 1 1-5.75 5.75 5.756 5.756 0 0 1 5.75-5.75zm0 10.165a4.415 4.415 0 1 0-4.415-4.415 4.42 4.42 0 0 0 4.415 4.415zm-.668-7.686h1.335v2.832l2.027.9-.526 1.226-2.836-1.248z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8240",
  d: "M7.322 20H.75a.75.75 0 0 1-.75-.75V8.5h1.5v10h5.822z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render };